import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box } from '@mui/material'
import React from 'react'
import LinkVariant from 'src/Elements/Buttons/LinkVariant'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  link: {
    cursor: 'pointer',
  },
}))

interface Props {
  isConnected: boolean
  onClickLink: () => void
}

/**
 * This component is used to disconnect an extension account from the installation.
 */
const DisconnectButton: React.FC<Props> = ({ isConnected, onClickLink }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()

  if (!isConnected) return null

  return (
    <Box>
      <LinkVariant
        type="button"
        hasUnderline={false}
        textClassName={classes.link}
        onClick={onClickLink}
        label={t('installation-extensions.direct-marketing.contract-status.button-text-delete')}
      />
    </Box>
  )
}

export default DisconnectButton
